import Connecticut from "./connecticut";
import Massachusetts from "./massachusetts";

const States = [Connecticut, Massachusetts];

export default States;
